setQueryRef